import { render, staticRenderFns } from "./view-testcase.vue?vue&type=template&id=4893b0b4&"
import script from "./view-testcase.ts?vue&type=script&lang=js&"
export * from "./view-testcase.ts?vue&type=script&lang=js&"
import style0 from "./view-testcase.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports